import React from 'react';
import { Images } from 'utils';
import { CloseButton } from '../buttons';
import { ManageActions } from '../tabs';

/**
 * The filter-icon button and its popover chrome, shared by every list grid that has one.
 *
 * Only the chrome lives here — the badge, the header, the scroll body, the "Reset all" footer and
 * the popover placement. The filter inputs themselves are `children`, because they are the one part
 * that genuinely differs per grid.
 *
 * Extracted because the markup was already duplicated verbatim across the schedule, Claims and
 * Claim Payments, and the grids being wired now would have made six copies of it. It renders the
 * same classes those three use (`filter-passive-btn`, `schedule-filter-popper-*`) so the styling
 * stays in one place too; the `schedule-` prefix is historical, the rules are global.
 *
 * `activeFiltersCount` drives three things at once — the button's active state, the badge, and
 * whether "Reset all" is enabled — so a grid that computes it wrong is visibly wrong in all three.
 * Count the same keys `onResetAll` clears and the chip bar charts, and the three cannot drift.
 */
export const FilterPopover = ({ activeFiltersCount = 0, onResetAll, children, minWidth = 280, wrapperStyles }) => (
    <ManageActions
        styleBodyItems={{ padding: 0 }}
        btnClass={`filter-passive-btn ${activeFiltersCount > 0 ? 'active-filter' : ''}`}
        renderBtnView={() => (
            <div>
                {activeFiltersCount > 0 && <div className="active-filters-count-badge">{activeFiltersCount}</div>}
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <img src={Images.filters} alt="icon" />
                </div>
            </div>
        )}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        wrapperStyles={{ position: 'relative', ...(wrapperStyles || {}) }}
        renderBody={(handleClose) => (
            <div style={{ minWidth }}>
                <div className="schedule-filter-popper-header">
                    <div className="flex-align-center" style={{ gap: 8 }}>
                        <img src={Images.filters} alt="icon" />
                        <p>Filters</p>
                    </div>
                    <CloseButton handleCLic={handleClose} />
                </div>

                <div className="schedule-filter-popper-body">
                    <div className="filter-popper-body-selectors">
                        {typeof children === 'function' ? children(handleClose) : children}
                    </div>
                </div>

                <div className="schedule-filter-popper-footer">
                    <button
                        disabled={activeFiltersCount === 0}
                        style={{
                            opacity: activeFiltersCount > 0 ? 1 : 0.5,
                            pointerEvents: activeFiltersCount > 0 ? 'auto' : 'none',
                        }}
                        onClick={() => onResetAll?.(handleClose)}
                    >
                        <img src={Images.revertWhite} alt="reset" />
                        <p>Reset all</p>
                    </button>

                    <p className="schedule-filter-footer-result">
                        {activeFiltersCount} result{activeFiltersCount !== 1 ? 's' : ''}
                    </p>
                </div>
            </div>
        )}
    />
);
